import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {    
  	validationArray:{
  		default:{}
  	},
    validationFinalCheck:false,
    validationRules:[],
    validationFinalResult:false,
    alertMsg:'',
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Validation/store/index.js